import { useNavigate } from "react-router-dom";
import { AppButton } from "./ui";
import { FieldProcessStepper } from "./FieldProcessStepper";
import type { JourneyResolved, JourneyStageStatus } from "../../domains/field/journey";

function mapStatus(status: JourneyStageStatus): "done" | "current" | "todo" | "blocked" {
  return status;
}

interface LifecycleStripProps {
  journey: JourneyResolved;
  /** Show Mode C primary CTA */
  showContinue?: boolean;
  continueLabel?: string;
  /** Compact title above the strip */
  title?: string;
}

/**
 * Mode A — full customer lifecycle strip.
 * Mode C — optional Continue journey button using the same resolver.
 */
export function LifecycleStrip({
  journey,
  showContinue = true,
  continueLabel = "Continue journey",
  title = "Customer journey",
}: LifecycleStripProps) {
  const navigate = useNavigate();

  return (
    <div className="pg-lifecycle">
      <div className="pg-lifecycle-head">
        <h3 style={{ margin: 0 }}>{title}</h3>
        {showContinue && journey.next ? (
          <AppButton
            type="button"
            onClick={() => navigate(journey.next!.href)}
            style={{ minHeight: 36, paddingInline: 12 }}
          >
            {continueLabel}
          </AppButton>
        ) : null}
      </div>
      <FieldProcessStepper
        variant="panel"
        ariaLabel="Customer lifecycle"
        steps={journey.stages.map((stage) => ({
          label: stage.label,
          state: mapStatus(stage.status),
          onSelect: () => navigate(stage.href),
        }))}
      />
      {journey.blockerSentence ? (
        <p className="pg-lifecycle-blocker" role="status">
          {journey.blockerSentence}
        </p>
      ) : null}
    </div>
  );
}
